<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Doctors",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Doctors",
            items: [
               {
                  text: "Doctors",
                  active: true,
               },                   
            ],

            doctors: [],
            doctor_status: {
               id: "",
               status: "",
            },
            listing_length: 10,
            keyword: '',
            status: '',
            from: null,
            to: null,
            total: null,
            pagination: {},
            token: "",
            errors: {},
            activate: false,
            deactivate: false,

            active_page_url: null,
            display: {
               doctor_id: "",
               status: "",
            },
         };
      },
      mounted() {
      this.clearLocalStorage();
      },

      created() {
         const savedFilters = localStorage.getItem("doctor_filters");

         if (savedFilters) {
            const filters = JSON.parse(savedFilters);

            // Restore values
            this.keyword = filters.keyword || "";
            this.listing_length = filters.listing_length || 10;
            this.active_page_url = filters.active_page_url || null;

            // Clear stored filters
            localStorage.removeItem("doctor_filters");

            // Fetch consultations using restored filters
            this.fetchDoctors(this.active_page_url);
         } else {
            this.fetchDoctors(); // Load normally if no stored filters
         }
      },

      methods: {

         clearLocalStorage() {
            localStorage.removeItem("consultation_filters");
            localStorage.removeItem("patient_filters");
            localStorage.removeItem("unscheduled_doctor_filters");

         },
         handleProfileClick(id) {
            this.opt_button = 1;  // Set opt_button first
            this.getDetailsRoute(id);  // Then call the route function
         },
          handleScheduleClick(id) {
            this.opt_button = 2;  // Set opt_button first
            this.getDetailsRoute(id);  // Then call the route function
         },

         handleSessionClick(id) {
            this.opt_button = 4;  // Set opt_button first
            this.getDetailsRoute(id);  // Then call the route function
         },
         handleBookingsClick(id) {
            this.opt_button = 3;  // Set opt_button first
            this.getDetailsRoute(id);  // Then call the route function
         },
         getDetailsRoute(id) {
            const filters = {
               keyword: this.keyword,
               listing_length: this.listing_length,
               active_page_url: this.active_page_url || this.$route.fullPath, // Store last visited page
            };
            localStorage.setItem("doctor_filters", JSON.stringify(filters)); // Save filters
            
            if (this.opt_button == 1) { // Now this check will pass
               this.$router.push({ name: "doctors.details", params: { id: id } });
            }else if (this.opt_button == 2) { // Now this check will pass
               this.$router.push({ name: "doctors.schedules", params: { id: id } });
            }else if (this.opt_button == 3) { // Now this check will pass
               this.$router.push({ name: "doctors.bookings", params: { id: id } });
            }else if (this.opt_button == 4) { // Now this check will pass
               this.$router.push({ name: "doctors.sessions", params: { id: id } });
            }
         },


         fetchDoctors(page_url) {

            this.getToken();
            let url = "clinic/scheduled-doctors?keyword=" + this.keyword + "&limit=" + this.listing_length;

            page_url = page_url || url;

            //if(localStorage.back_url) {
            //   page_url = localStorage.back_url;  
            //   localStorage.removeItem('back_url');
            //}    

            this.active_page_url = page_url;
            this.loading = true;
            
            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.doctors = responseData.doctors.data;
                  
                  this.pagination = responseData.doctors.links;
                  this.from = responseData.doctors.from;
                  this.to = responseData.doctors.to;
                  this.total = responseData.doctors.total;
               
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         }, 


         // disableName(doctor_id){

         //          this.getToken();           
            
         //          const config = {
         //             headers: {
         //                "Content-type": "application/json",
         //                "Accept": "application/json",
         //                "Authorization": "Bearer " + this.token,
         //             },
         //          };
                 
         //          let url = "clinic/doctor/disableName?doctor_id=" + doctor_id;
         //          this.$axios
         //          .get(url, config)
         //          .then((response) => {
         //                if (response.data.status) {
         //                   this.$swal("", response.data.message, "success");
         //                } else {
         //                   this.$swal("", response.data.message, "error");
         //                }
         //                this.fetchDoctors(this.active_page_url);
         //          })
         //          .catch((error) => {
         //             if (error.response) {
         //                if (error.response.data.message) {
         //                   this.errors = error.response.data.message;
         //                   //console.log(this.errors);
         //                } else {
         //                   this.$swal("", "Something went wrong", "error");
         //                }
         //             } else {
         //                this.$swal("", "Something went wrong", "error");
         //             }
         //          })
         //          .finally(() => (this.loading = false));

         // },
         enableName(doctor) {
            this.activate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to enable display name?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
              .then(value => {
                  this.activate = value
                  if(this.activate){
                  this.display.doctor_id = doctor.id;
                  this.display.status = 1;
                  this.updateDisplayStatus();
               }
              })
               .catch(err => {
                  console.log(err);
              })
         },
         disableName(doctor) {
            this.deactivate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to disable display name?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
               .then(value => {
                  this.deactivate = value
                  if(this.deactivate){
                  this.display.doctor_id = doctor.id;
                  this.display.status = 2;
                  this.updateDisplayStatus();
               }
               })
               .catch(err => {
                  console.log(err);
               })
         },
         updateDisplayStatus() {
            
            this.getToken();
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };
            let url = "clinic/doctor/disableName?doctor_id=" + this.display.doctor_id + "&display_name=" + this.display.status;
            this.$axios
               .get(url, config)
               .then((response) => {                  
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.fetchDoctors(this.active_page_url);
               })
               .catch((error) => {                
                  if (error.response) {
                     if (error.response.data.message) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               });
         }, 
         

         getToken() {
            if (localStorage.getItem('medicino_clinic')) {
               var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
               if(medicino_clinic.token) {
                  this.token = medicino_clinic.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <router-link :to="{ name: 'doctors.add' }" class="btn btn-primary float-end">Add Doctor</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchDoctors()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchDoctors()"/>
                           </label>
                        </div> 

                        <!-- <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status">
                                 <option value="">All</option>
                                 <option value="1">Published</option>
                                 <option value="2">Unpublished</option>
                              </select>
                           </label>
                        </div>                          -->
                        
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>Name</th>  
                              <th>Contact</th>
                              <th>Specializations</th> 
                              <th>Display Name</th>
                              <th>Created On</th>                              
                              <th>Options</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(doctors.length)">
                           <tr v-for="(doctor) in doctors" :key="doctor.id">
                              <td><span v-if="doctor.prefix == 1">Dr.</span><span v-else-if="doctor.prefix == 2">Mr.</span><span v-else-if="doctor.prefix == 3">Ms.</span> {{doctor.name}}</td>                      
                              <td>
                                 {{doctor.country_code}} {{doctor.mobile}}<br>
                                 {{doctor.email}}<br>
                              </td>

                              <td>
                                 <span v-for="specialization in doctor.specializations" :key="specialization.id">
                                    {{specialization.specialization}}<br>
                                 </span>
                              </td>

                              <td v-if="doctor.display_name === 1 ">Yes</td>
                              <td v-if="doctor.display_name === 2">No</td>

                              <td>{{doctor.converted_created_at}}</td>
                             
                              <td>

                                 <!--<router-link :to="{ name: 'doctors.details', params: {id: doctor.id} }" class="btn btn-primary me-2 mb-2 btn-sm">Profile</router-link>-->
                                 <button @click="handleProfileClick(doctor.id)" class="btn btn-primary me-2 mb-2 btn-sm" type="button">Profile</button>

                                 <!--<router-link :to="{ name: 'doctors.schedules', params: {id: doctor.id} }" class="btn btn-primary me-2 mb-2 btn-sm">Schedules</router-link>-->
                                 <button @click="handleScheduleClick(doctor.id)" class="btn btn-primary me-2 mb-2 btn-sm" type="button">Schedules</button>

                                 <button @click="handleSessionClick(doctor.id)" class="btn btn-primary me-2 mb-2 btn-sm" type="button">Sessions</button>

                                 <!--<router-link :to="{ name: 'doctors.bookings', params: {id: doctor.id} }" class="btn btn-primary me-2 mb-2 btn-sm">Bookings</router-link>  -->   
                                 <button @click="handleBookingsClick(doctor.id)" class="btn btn-primary me-2 mb-2 btn-sm"  type="button">Bookings</button>
                                 <router-link :to="{ name: 'doctors.schedule.changes', params: {id: doctor.id} }" class="btn btn-primary me-2 mb-2 btn-sm">Leaves</router-link>
                                 
                                 <!-- <b-button variant="danger" v-if="doctor.display_name === 1" @click="disableName(doctor.id)" class="btn-sm me-2 mb-2" >Disable Display Name</b-button> -->

                                 <b-button v-if="doctor.display_name==1" variant="danger" class="btn-sm me-2 mb-2" @click="disableName(doctor)">Disable Display Name</b-button>
                                 <b-button v-else variant="success" class="btn-sm mb-2 me-2" @click="enableName(doctor)">Enable Display Name</b-button>
                              </td>
                           </tr>
                 
                        </tbody>

                        <tbody v-else>
                           <tr>
                              <td colspan="5" class="text-center">No doctors found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts --->     
                  <caption v-if="Boolean(doctors.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchDoctors(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&status=' + status )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
